// Hideo - Teleprompter without UI (TeleprompterDialog.vue, state in src/stores/teleprompter.ts): the sliders' limits
// and the scrolling. Ported from the legacy editor/teleprompter.js (verbatim copy in tests/fixtures/legacy): same speed
// for every slider step, so the text moves exactly as before.

/** Speed slider: 1–20, 5 at the start */
export const TP_SPEED = { min: 1, max: 20, start: 5 } as const
/** Text size slider (px): 24–110, 52 at the start */
export const TP_SIZE = { min: 24, max: 110, start: 52 } as const
/** Pixels per second for each step of the speed slider */
export const TP_PX_PER_STEP = 8

/** Where the text is after ms milliseconds at this speed (pixels from the top, not rounded) */
export const tpAdvance = (pos: number, speed: number, ms: number): number => pos + speed * TP_PX_PER_STEP * ms / 1000
/** The scrolling reached the end of the text: the position is at or past the last one the box can show */
export const tpAtEnd = (pos: number, scrollHeight: number, clientHeight: number): boolean => pos >= scrollHeight - clientHeight
